var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgInformatica = _a => {
  var _b, _c, _d, _e, _f;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_4865_3)"
  }, React.createElement("path", {
    d: "M20.4195 14.1297V4.89624C20.4195 4.11487 19.7885 3.47644 19.0163 3.47644H4.98374C4.21148 3.47644 3.58049 4.11487 3.58049 4.89624V14.1297H20.4289H20.4195Z",
    stroke: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M22.4067 18.5225C22.7175 19.2372 22.4067 20.0757 21.6909 20.3997C21.512 20.4759 21.3142 20.5236 21.1164 20.5236H2.87414C2.10188 20.5236 1.47089 19.8851 1.47089 19.1038C1.47089 18.9037 1.50856 18.7131 1.59332 18.5225L3.58048 14.1297H20.4289L22.4161 18.5225H22.4067Z",
    stroke: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.5967 17.684H13.4032",
    stroke: (_e = props.color) !== null && _e !== void 0 ? _e : 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4865_3"
  }, React.createElement("rect", {
    width: 22,
    height: 18,
    fill: (_f = props.color) !== null && _f !== void 0 ? _f : 'currentColor',
    transform: "translate(1 3)"
  }))));
};
export default SvgInformatica;